/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RegularButton } from 'pg-ui-library';
import { Container, Header, HeaderLine } from './styles';

import { EmployeePayStatementsTable } from './components/employee-pay-statements-table';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';
import { exportToXLSX } from 'src/utils/xlsxConverter';
import PaymentsService from 'src/services/payments.service';
import { IPayStatement } from 'src/interfaces';

export const EmployeePayHistoryTab: React.FC = () => {
  const { t } = useTranslation();

  const { selectedEmployee } = useTypedSelector(state => state.employees.data);
  const [selectedPayslips, setSelectedPayslips] = useState<IPayStatement[]>([]);
  const [allPtn, setAllPtn] = useState<string[]>([]);
  const { config } = useTypedSelector(state => state.config.data);
  const handleChange = ({ selectedRows }: { selectedRows: IPayStatement[]; allSelected: boolean }) => {
    setSelectedPayslips(selectedRows);
  };

  useEffect(() => {
    const updatedPtn = selectedPayslips.map((element: IPayStatement) => element.payStatementNumber);
    setAllPtn(updatedPtn);
  }, [selectedPayslips]);

  const exportToExcel = (): void => {
    exportToXLSX(selectedEmployee.payStatements || [], 'pay-statements', 'pay-statements-employee');
  };
  return (
    <Container>
      <Header>
        <div>
          <span>{t('employeePage.payHistory.title')}</span>
        </div>
        <HeaderLine />
        {!selectedEmployee.payStatements || selectedEmployee.payStatements.length === 0 ? (
          ''
        ) : (
          <div>
            <div>
              <RegularButton onClick={exportToExcel}>{t('global.form.exportExcel')}</RegularButton>
            </div>
            <div>
              <a
                target="_blank"
                href={PaymentsService.getSelectedPayStubPdf({
                  ptn: allPtn || '',
                  companyId: config?.selectedCompanyId || '',
                  employeeId: selectedEmployee.employee?.id || '',
                  downloadFile: true,
                })}
              >
                <RegularButton disabled={selectedPayslips.length <= 0}>
                  {t('global.form.exportSelectedPay')}
                </RegularButton>
              </a>
            </div>
          </div>
        )}
      </Header>
      <EmployeePayStatementsTable handleChange={handleChange} />
    </Container>
  );
};
